import { render, staticRenderFns } from "./registerInfo.vue?vue&type=template&id=4e3c13b0&scoped=true&"
import script from "./registerInfo.vue?vue&type=script&lang=js&"
export * from "./registerInfo.vue?vue&type=script&lang=js&"
import style0 from "./registerInfo.vue?vue&type=style&index=0&id=4e3c13b0&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3c13b0",
  null
  
)

export default component.exports